import { render } from "./RoleAccessSection.vue?vue&type=template&id=1155eca4&scoped=true&ts=true"
import script from "./RoleAccessSection.vue?vue&type=script&lang=ts"
export * from "./RoleAccessSection.vue?vue&type=script&lang=ts"

import "./RoleAccessSection.vue?vue&type=style&index=0&id=1155eca4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1155eca4"]])

export default __exports__